import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
import DashedBorderSixFeatures from "components/features/DashedBorderSixFeatures";
import TwoColSingleFeatureWithStats from "components/features/TwoColSingleFeatureWithStats";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo";
import Building from "../../images/realestate1.png"
import Building2 from "../../images/realestate3.png"

import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";
import GetStarted from "components/cta/GetStarted";
import SEO from "components/SEO";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
         <SEO
title="Realestate Page" 
description="Realestate Page"
/>
      <TwoColumnWithVideo
       heading="Real Estate Software Development and Software Solutions"
       buttonRounded={false}
       primaryButtonText="Request free consultation"
       primaryButtonUrl = "https://calendly.com/solutions-tbnw/30min?month=2024-11"
       description="As the economy grows, the demand for real estate continues to rise, creating a need for efficient management of properties, transactions, and tenants. To stay competitive, real estate businesses must streamline their operations, reduce manual processes, and improve customer experiences. Technology and automation are essential tools in optimizing these workflows, enabling businesses to manage large volumes of data, track property listings, and improve communication with clients.

Metromidas offers custom software solutions"
       imageSrc={Building2}
       />

<MainFeature1
        subheading={<Subheading></Subheading>}
        heading="Create Advanced Real Estate Solutions with Our Expert Software Development Services."
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl = "/contactus"
        description="
We can help you uncover the hidden revenue opportunities to showcase your properties and connect with prospective buyers through technology. We offer complete real estate software solutions with top-most real estate services."
        imageSrc={Building}
        textOnLeft={false}
      />
       <GetStarted />

<TwoColContactUsWithIllustrationFullForm />
      <Footer />
    </AnimationRevealPage>
    
  );
};
